import moment from "moment-timezone";
import { useSelector } from "react-redux";
import ArrowIcon from "../../../components/icons/ArrowIcon";
import ArrowIconLeft from "../../../components/icons/ArrowIconLeft";
import {
  OnestBoldBig,
  OnestNormalBig,
  OnestNormalDefault,
} from "../../../components/styled/TextComponents";
import {
  color_black,
  color_grey_dark,
  color_grey_light,
  color_white,
} from "../../../constants/colors";
import { useWindowDimensions } from "../../../utils";
import { MOBILE_HEADER_WIDTH } from "./scheduleConstants";
import { useI18n } from "../../../i18n/I18nProvider";

const MONTH_NAMES = [
  "ЯНВ",
  "ФЕВ",
  "МАР",
  "АПР",
  "МАЙ",
  "ИЮН",
  "ИЮЛ",
  "АВГ",
  "СЕН",
  "ОКТ",
  "НОЯ",
  "ДЕК",
];
const MONTH_FULL_NAMES = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

const ScheduleHeader = ({ scheduleWeekRange, setScheduleWeekRange }) => {
  const { t } = useI18n();
  const { width: screenWidth } = useWindowDimensions();
  const user = useSelector((state) => state.user);
  const timeZone =
    user.time_zone || Intl.DateTimeFormat().resolvedOptions().timeZone;

  const formattedDate = moment().tz(timeZone);

  const scheduleWEekRangeShortString = () => {
    return (
      `${moment(scheduleWeekRange[0]).format("DD")} ${t(MONTH_NAMES[moment(scheduleWeekRange[0]).month()])} — ` +
      `${moment(scheduleWeekRange[1]).format("DD")} ${t(MONTH_NAMES[moment(scheduleWeekRange[1]).month()])}`
    );
  };

  const setPreviousWeek = () => {
    let weekStart = formattedDate;
    if (scheduleWeekRange && scheduleWeekRange[0]) {
      weekStart = scheduleWeekRange[0];
    } else {
      const dayOfWeek = weekStart.day();
      const diffToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
      weekStart = moment(weekStart)
        .subtract(diffToMonday, "days")
        .startOf("day");
    }
    weekStart.subtract(7, "days");

    let weekEnd = formattedDate;
    if (scheduleWeekRange && scheduleWeekRange[1]) {
      weekEnd = scheduleWeekRange[1];
    } else {
      const dayOfWeek = weekEnd.day();
      const diffToSunday = dayOfWeek === 0 ? 0 : 7 - dayOfWeek;
      weekEnd = moment(weekEnd).add(diffToSunday, "days").endOf("day");
    }
    weekEnd.subtract(7, "days");

    setScheduleWeekRange([weekStart, weekEnd]);
  };

  const setNextWeek = () => {
    let weekStart = moment(scheduleWeekRange[0]);
    weekStart.add(7, "days");
    let weekEnd = moment(scheduleWeekRange[1]);
    weekEnd.add(7, "days");
    setScheduleWeekRange([weekStart, weekEnd]);
  };

  const setCurrentSeasonImage = (m) => {
    let img = "fall.jpg";
    if (m === 11 || m === 0 || m === 1) {
      img = "winter.jpg";
    }
    if (m === 2 || m === 3 || m === 4) {
      img = "spring.jpg";
    }
    if (m === 5 || m === 6 || m === 7) {
      img = "summer.jpg";
    }
    if (m === 8 || m === 9 || m === 10) {
      img = "fall.jpg";
    }
    return process.env.PUBLIC_URL + "/" + img;
  };

  const startMonth = t(MONTH_FULL_NAMES[moment(scheduleWeekRange[0]).month()]);
  const endMonth = t(MONTH_FULL_NAMES[moment(scheduleWeekRange[1]).month()]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: screenWidth > MOBILE_HEADER_WIDTH ? "row" : "column",
        justifyContent:
          screenWidth > MOBILE_HEADER_WIDTH ? "space-between" : "flex-start",
        alignItems: "center",
        gap: 10,
      }}
    >
      {screenWidth < MOBILE_HEADER_WIDTH &&
        setCurrentSeasonImage(moment(scheduleWeekRange[0]).month()) && (
          <img
            src={setCurrentSeasonImage(moment(scheduleWeekRange[0]).month())}
            alt="season"
            style={{
              width: screenWidth - 40,
              borderRadius: 10,
              height: "auto",
            }}
          />
        )}
      <div style={{ display: "flex", flexDirection: "row" }}>
        <OnestBoldBig style={{ marginRight: 8 }}>
          {startMonth === endMonth
            ? startMonth
            : `${startMonth} - ${endMonth}`}
          ,{" "}
        </OnestBoldBig>
        <OnestNormalBig style={{ color: color_grey_dark }}>
          {moment(scheduleWeekRange[0]).year()}
        </OnestNormalBig>
      </div>
      <div style={{ display: "flex", flexDirection: "row", gap: 2 }}>
        <div
          style={{
            backgroundColor: color_white,
            width: 32,
            height: 32,
            borderTopLeftRadius: 100,
            borderBottomLeftRadius: 100,
            color: color_black,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            padding: 5,
            fontSize: 20,
            cursor: "pointer",
          }}
          onClick={() => setPreviousWeek()}
        >
          <ArrowIconLeft fill={color_grey_light} />
        </div>
        <div
          style={{
            height: 32,
            backgroundColor: color_white,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            padding: 5,
            width: 150,
          }}
        >
          <OnestNormalDefault>
            {scheduleWEekRangeShortString()}
          </OnestNormalDefault>
        </div>
        <div
          style={{
            backgroundColor: color_white,
            width: 32,
            height: 32,
            borderTopRightRadius: 100,
            borderBottomRightRadius: 100,
            color: color_black,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            padding: 5,
            fontSize: 20,
            cursor: "pointer",
          }}
          onClick={() => setNextWeek()}
        >
          <ArrowIcon fill={color_grey_light} />
        </div>
      </div>
    </div>
  );
};

export default ScheduleHeader;
